import { createSelector } from "@reduxjs/toolkit";

import { discoveryPanelsSelector } from "./discoveryPanels.selector";

export const explorerSelector = createSelector(
  discoveryPanelsSelector,
  state => state.explorer
);